import { RefundModel } from 'api-hooks/refund/refund';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import { ScheduleCardHeader } from 'legacy-modules/sales/activity/style';
import {
  CardSection,
  FullContainer,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import AddonsActivityTable from './addons-activity';
import GuestActivityDetailTable from './guest-activity-detail';

interface Props {
  refund?: RefundModel;
}

export default function ActivityPurchaseSection(props: Props) {
  const { control } = useFormContext();
  const name = 'activityPurchases';
  const { fields } = useFieldArray({
    control,
    name,
    keyName: 'customId',
  });

  const { t } = useTranslation();

  if (fields.length === 0) {
    return null;
  }

  return (
    <>
      <Separator gap={24} />
      {fields.map((field, index) => {
        return (
          <React.Fragment key={field.customId}>
            <CardSection>
              <FullContainer>
                <ScheduleCardHeader>
                  <Text variant="HeadingXSmall">
                    {t('common:other_purchase_detail')} {index + 1}
                  </Text>
                </ScheduleCardHeader>
                <Separator gap={24} />

                <GuestActivityDetailTable
                  parentIndex={index}
                  refund={props.refund}
                />
                <Separator gap={24} />

                <AddonsActivityTable
                  parentIndex={index}
                  refund={props.refund}
                />
              </FullContainer>
            </CardSection>
            <SeparatorVertical $margin={32} />
          </React.Fragment>
        );
      })}
    </>
  );
}
